import type { FC } from 'react';
import Tooltip from '@components/Tooltip';
import { controlClasses } from '@WysiwygEditor/components/Controls/classes';
import { FileInput } from 'lucide-react';

interface ImportFileToolbarButtonProps {
  isActive: boolean;
  isConverting: boolean;
  onClick: () => void;
}

export const ImportFileToolbarButton: FC<ImportFileToolbarButtonProps> = ({ isActive, isConverting, onClick }) => (
  <Tooltip content="Import file content">
    <button
      aria-label="Import file content"
      aria-pressed={isActive}
      className={controlClasses({ isActive, isDisabled: isConverting })}
      disabled={isConverting}
      onClick={onClick}
      type="button"
    >
      <FileInput size={18} />
    </button>
  </Tooltip>
);
